import { 
    gql, 
  useQuery 
} from "@apollo/client";
import { QueryWithdrawalOverviewAdminArgs, WithdrawalOverviewAdminQueryQuery } from "../../../../../schemaTypes";

export const withdrawalOverviewAdminQuery = gql`
  query WithdrawalOverviewAdminQuery(
    $duration: String!
  ) {
    withdrawalOverviewAdmin(
      duration: $duration 
    ) {
        totalWithdrawals
        pendingWithdrawals
    }
  }
`;

export interface WithWithdrawalOverviewAdmin {
  totalWithdrawals: number;
  pendingWithdrawals: number;
}

interface Props {
  variables: QueryWithdrawalOverviewAdminArgs;
  children: (data: WithWithdrawalOverviewAdmin) => React.ReactElement | null;
}

export const WithdrawalOverviewAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    WithdrawalOverviewAdminQueryQuery,
    QueryWithdrawalOverviewAdminArgs
  >(withdrawalOverviewAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  const totalWithdrawals = data?.withdrawalOverviewAdmin.totalWithdrawals || 0;
  const pendingWithdrawals = data?.withdrawalOverviewAdmin.pendingWithdrawals || 0;


  return children({
        totalWithdrawals,
        pendingWithdrawals,
  });
};